export const BaseUrl = "https://costing-backend.rupioo.com";
// export const BaseUrl = "http://192.168.29.59:5010";
